import React, { useMemo } from 'react';
import { runRecordValidators } from './recordValidators';
import { variantClass } from '../../../../util/variant';

const FormValidationSummary = ({ data, show = true, onSelect, variant, title }) => {
    const { recordLevel, fieldLevel, hasErrors } = useMemo(
        () => runRecordValidators(data),
        [data],
    );

    if (!show || !hasErrors) return null;

    const count = recordLevel.length + fieldLevel.length;
    const heading = title
        || (count === 1 ? 'One thing needs fixing before you continue' : `${count} things need fixing before you continue`);

    return (
        <div
            className={`docfirst__summary ${variantClass(variant)}`.trim()}
            role="alert"
            data-testid="business-v2-validation-summary"
        >
            <div className="docfirst__summary-head">{heading}</div>

            {recordLevel.map((item) => (
                <div className="docfirst__summary-item" key={item.key}>
                    {item.message}
                </div>
            ))}

            {fieldLevel.length > 0 && (
                <ul className="docfirst__summary-list">
                    {fieldLevel.map((item) => (
                        <li key={item.key}>
                            {item.person ? <strong>{item.person}</strong> : null}
                            {item.person ? ' — ' : null}
                            {onSelect ? (
                                <button
                                    type="button"
                                    className="docfirst__summary-link"
                                    onClick={() => onSelect(item)}
                                >
                                    {item.message}
                                </button>
                            ) : (
                                item.message
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default FormValidationSummary;

